import { offset } from '@floating-ui/dom';
import { customScrollTo, awaitElPromise } from '../reading/toolTipUtils';
import {
    DATA_TOUR_INTERACTION_MAPPER,
    DATA_TOUR_STEP_MAPPER,
    STEP,
} from '../../constants/reading/DemoModeConstants';

export const generateSteps = (toolTipsJson, stepIds, func) => {
    const SecondaryButtonStyle = 'btn btn-oval btn-secondary rhythm-button';
    const PrimaryButtonStyle = 'btn btn-oval btn-primary rhythm-button';
    return stepIds.map((stepId, idx) => {
        const step = toolTipsJson.steps[stepId];
        const prevStepId = idx > 0 && stepIds[idx - 1];
        let stepOptions = {
            attachTo: {
                element: `[data-tour-step="${step.element}"]`,
                on: step.position,
            },
            appendTo: document.body,
            id: stepId,
            text: step.text,
            floatingUIOptions: {
                middleware: [offset(12)],
            },
            modalOverlayOpeningPadding: 0,
            classes: '',
            buttons: [
                {
                    classes: SecondaryButtonStyle,
                    text: 'Previous',
                    type: '',
                    action() {
                        if (this.getCurrentStep().id === STEP[1]) {
                            func.setActiveTourStepId(STEP[0]);
                            this.back();
                        }
                        if (idx > 0 && toolTipsJson.steps[prevStepId]?.location.length > 0) {
                            func.updateLocation(toolTipsJson.steps[prevStepId]?.location);
                            this.back();
                        }
                    },
                },
                {
                    classes: PrimaryButtonStyle,
                    text: 'Next',
                    type: 'next',
                },
            ],
            scrollToHandler: () => customScrollTo(step),
        };
        if (step.waitForElement) {
            stepOptions = {
                ...stepOptions,
                beforeShowPromise() {
                    return new Promise(resolve => {
                        awaitElPromise(stepId, step, resolve);
                    });
                },
            };
        }
        if (step.isInteractive) {
            stepOptions = {
                ...stepOptions,
                buttons: [{ classes: PrimaryButtonStyle, ...stepOptions.buttons[0] }],
                advanceOn: {
                    selector: `[data-tour-step="${step.element}"]`,
                    event: 'click',
                },
            };
        }
        if (idx === 0) {
            stepOptions = {
                ...stepOptions,
                buttons: [
                    {
                        classes: PrimaryButtonStyle,
                        text: 'Next',
                        type: 'next',
                    },
                ],
            };
        }
        if (idx === stepIds.length - 1) {
            stepOptions = {
                ...stepOptions,
                buttons: [
                    {
                        classes: SecondaryButtonStyle,
                        text: 'Previous',
                        type: 'back',
                    },
                    {
                        classes: PrimaryButtonStyle,
                        text: 'Next',
                        type: '',
                        action() {
                            func.onShowCompleteModal();
                        },
                    },
                ],
            };
        }
        return stepOptions;
    });
};

//  Strip the target element's name to use lowercase in toolTips json config
const formatEl = targetElName => {
    let idName;
    if (typeof targetElName === 'string') {
        idName = targetElName?.toLowerCase().replace(/[^A-Z0-9]+/gi, '');
    }
    if (targetElName && typeof targetElName === 'number') {
        idName = targetElName
            ?.toString()
            .toLowerCase()
            .replace(/[^A-Z0-9]+/gi, '');
    }
    return idName;
};

export const createDataTourStep = targetElName => {
    const formattedEl = formatEl(targetElName);
    if (DATA_TOUR_STEP_MAPPER[formattedEl]) {
        return DATA_TOUR_STEP_MAPPER[formattedEl];
    }
    return '';
};

export const setDataTourInteraction = targetElName => {
    const formattedEl = formatEl(targetElName);
    if (DATA_TOUR_INTERACTION_MAPPER[formattedEl]) {
        return DATA_TOUR_INTERACTION_MAPPER[formattedEl];
    }
    return false;
};

export const isInWidthViewport = element => {
    const rect = element.getBoundingClientRect();
    const elementMiddle = (rect.left + rect.right) / 2;
    return (
        elementMiddle >= 0 &&
        elementMiddle <= (window.innerWidth || document.documentElement.clientWidth)
    );
};
